var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-container"},[_c('a-directory-tree',{attrs:{"tree-data":_vm.treeData,"expand-action":false,"replace-fields":_vm.replaceFields,"icon":_vm.getIcon,"show-icon":true,"default-expand-all":true,"selected-keys":_vm.selectedKeys},on:{"select":_vm.selectNode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }